<template>
    <div class="service">
        <section id="services" class="services section">

            <!-- Section Title -->
            <div class="container section-title" data-aos="fade-up">
                <h2>{{title}}</h2>
            </div><!-- End Section Title -->

            <div class="container justify-content-center">

                <div class="row gy-4 justify-content-center">
                    <div class="col-lg-4 col-md-6 justify-content-center" data-aos="fade-up" data-aos-delay="100" v-for="item in dataLayanan" :key="item.id">
                        <div class="service-item  position-relative">
                        <div class="icon">
                            <i :class="item.icon"></i>
                        </div>
                        <a href="#" class="stretched-link">
                            <h3>{{ item.name }}</h3>
                        </a>
                        <p>{{ item.description }}</p>
                        </div>
                    </div><!-- End Service Item -->

                </div>

            </div>

        </section>
    </div>
</template>
<script>
import ServiceJs from './js/app.js';
export default ServiceJs;
</script>